<template>
	<div>
		<div class="sf-search-layout__body__container">
			<sf-search-layout>
				<el-row :gutter="20">
					<!--업체판매일 , 임시) 날짜구분-->
					<el-col :span="3">
						<select-combo
							:label="getMessage_('QWCC001393')"
							paramKey="srchMm03"
							:options="companySaleList"
							:propData="searchParams.srchMm03"
							@commChange="setSearchParam"
						></select-combo>
					</el-col>
					<!--검색날짜-->
					<el-col :span="5">
						<sf-group-wrapper :label="getMessage_('QWCC001394')">
							<el-date-picker
								v-model="searchDate"
								@change="changeSearchSrchMm03"
								type="daterange"
								align="right"
								:start-placeholder="getMessage_('QWCC000920')"
								:end-placeholder="getMessage_('QWCC000954')"
								range-separator="~"
								format="yyyy-MM-dd"
								style="height: 38px"
							/>
						</sf-group-wrapper>
					</el-col>
					<el-col :span="3">
						<search-input
							:label="getMessage_('QWCC000960')"
							paramKey="carVin"
							@commInput="setSearchParam"
							:clearable="false"
							:propData="searchParams.carVin"
						>
						</search-input>
					</el-col>
					<el-col :span="3">
						<search-input
							:label="getMessage_('QWCC001538')"
							paramKey="pmcId"
							@commInput="setSearchParam"
							:clearable="false"
							:propData="searchParams.pmcId"
						>
						</search-input>
					</el-col>
					<el-col :span="3">
						<search-input
							:label="getMessage_('QWCC002109')"
							paramKey="cpnyNm"
							@commInput="setSearchParam"
							:clearable="false"
							:propData="searchParams.cpnyNm"
						>
						</search-input>
					</el-col>
					<el-col :span="3">
						<search-input
							:label="getMessage_('QWCC002119')"
							paramKey="licensePlate"
							@commInput="setSearchParam"
							:propData="searchParams.licensePlate"
						></search-input>
					</el-col>
					<el-col :span="2">
						<div class="sf-input-group-wrapper">
							<span class="sf-input-group-wrapper__label">&nbsp;</span>
							<div>
								<el-checkbox @input="value => onCheck('lastYn', value)">{{ getMessage_('QWCC001886') }}</el-checkbox>
							</div>
						</div>
					</el-col>
				</el-row>
				<template slot="button">
					<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
						{{ getButtonMsg_(scrId, 'CR') }}
					</sf-button>
				</template>
			</sf-search-layout>
			
		</div>
	</div>
</template>

<script>
import SearchInput from '@qms/Components/SearchInput';
import SelectCombo from '@qms/Components/SelectCombo';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
export default {
	props: { scrId: { type: String, default: '' } },
	components: { SearchInput, SelectCombo },
	data() {
		return {
			searchDate: ['', '']
		};
	},
	async created() {
		try {
			await this.postSearchSelectList_();
			// this.searchDateRange = [...this.getSearchDates_];
			// await this.getCommCodes_({ key: 'oputStCdList', codeType: 'OPUT_ST' });
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message || error
			});
		}
	},
	// watch: {
		
	// 	searchDateRange(newValue) {
	// 		if (newValue == null) {
	// 			this.setSearchParam_({ key: 'strDt', value: '' });
	// 			this.setSearchParam_({ key: 'endDt', value: '' });
	// 		}
	// 		if (newValue?.length == 2) {
	// 			const strDt = this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
	// 			const endDt = this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
	// 			this.setSearchParam_({ key: 'strDt', value: strDt });
	// 			this.setSearchParam_({ key: 'endDt', value: endDt });
	// 		}
	// 	}
	// },
	components: { SearchInput, SelectCombo },
	methods: {
		...rootMethods,
		...serviceMethods,
		changeSearchSrchMm03(data) {
			let from;
			let to;
			if (data) {
				from = this.$moment(data[0]).format('YYYY-MM-DD');
				to = this.$moment(data[1]).format('YYYY-MM-DD');
			}

			//this.searchDate1 = [from, to];
			this.selectDate({ from, to });
		},
		async getPmc({ pmcId, ipnNos,  }) {
			// this.$sf_toggleLoading(true);
			this.setSearchParam_({ key: 'pmcId', value: pmcId });
			this.setSearchParam_({ key: 'ipnNos', value: ipnNos });
			// this.setSearchParam_({ key: 'custCd', value: custCd });
			// this.setSelectedRow_({ key: 'pmcNo', value: pmcNo });
			// this.setSelectedRow_({ key: 'ipnNos', value: ipnNos });
			// this.setSelectedRow_({ key: 'custCd', value: custCd });
			// this.setSelectedRow_({ key: 'custNm', value: custNm });
			// await this.getList_();
			// this.$sf_toggleLoading(false);
		},
		onCheck(key, value) {
			// console.log(value);
			if (value) {
				this.setSearchParam_({ key, value: 'Y' });
			} else {
				this.setSearchParam_({ key, value: 'N' });
			}
		},
		setSearchParam(param) {
			if (param.key === 'pmcId') {
				this.setSearchParam_({ key: 'ipnNos', value: '' });
			}
			this.setSearchParam_(param);
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				if (!this.isMqyUser) throw new Error(this.getMessage_('QWCC001923')); //해당메뉴에 접근 권한이 없습니다. 관리자에게 권한을 요청하세요.
				await this.getList_();
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error?.message
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
